import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

export const useGetPartnerDetailQuery = (partnerId: number) => {
  const { getPartnerDetail } = useServicesContext();

  return useQuery({
    queryKey: ['GET_PARTNER_DETAIL', partnerId],
    queryFn: () => getPartnerDetail(partnerId),
    enabled: Boolean(partnerId),
  });
};
